module.exports = __webpack_public_path__ + "img/signupLogo.638a147d.svg";